jQuery(function () {
	//IE11 Detection
	var IE11 = !!(
		navigator.userAgent.match(/Trident/) &&
		navigator.userAgent.match(/rv[ :]11/)
	)
	if (IE11 === true) {
		$('html').addClass('IE11')
	}

	//Product Page Item description collapse and tabs
	$(function () {
		const $tabLinksWrap = $('#tabs > .tab-links')
		const $tabFirstBtn = $tabLinksWrap.find('button').eq(0)

		$('#tabs > div').hide()
		$('#tabs > div:first').show()
		$tabFirstBtn.addClass('active')

		$tabLinksWrap.on('click', 'button', function () {

			const $this = $(this)
			const $sibling = $this.siblings()

			$sibling.removeClass('active').attr({
				'tabindex': '-1',
				'aria-selected': 'false'
			})

			$this.addClass('active').attr({
				'tabindex': '0',
				'aria-selected': 'true'
			})

			var currentTab = $this.attr('aria-controls')
			$('#tabs > div').hide()
			$(`#${currentTab}`).show()

			return false
		})
	})

	$(window).on('load', function () {
		$('.item-image, .slider').flexslider({
			animation: 'slide',
			animationLoop: false,
			useCSS: false,
		})
	})
	if (document.body.classList.contains('pghome')) {
		function checkWidth() {
			var viewportWidth = document.documentElement.clientWidth
			if (viewportWidth < 768) {
			} else {
			}
		}
		checkWidth()
		window.addEventListener('resize', function () {
			checkWidth()
		})
	}
})
function videoHovering() {
	if (document.body.classList.contains('pghome')) {
		$(window).on('load', function () {
			const video = document.querySelector('.pillow-video-wrap video')
			video.addEventListener('mouseover', function (e) {
				video.play()
			})
			video.addEventListener('mouseout', function (e) {
				video.pause()
			})
		})
	}
}

function initializeTabNavigation() {
	const $tabLinksWrap = $(".swiper-container").find(".swiper-wrapper");
	const $tabFirstBtn = $tabLinksWrap.find('button').eq(0);
	const $tabs = $("#tabs > div");

	// Hide all tabs except the first one
	$tabs.hide();
	$tabs.first().show();
	$tabFirstBtn.addClass('active');

	// Add click event listener to tab buttons
	$tabLinksWrap.on('click', 'button', function () {
		const $this = $(this);
		const previousTabId = "#" + $tabLinksWrap.find('.active').attr('aria-controls');
		const previousAnchor = $(previousTabId).find("a:first-child");
		previousAnchor.attr("tabindex", "-1");

		const $sibling = $this.siblings();
		$sibling.removeClass('active').attr({
			'tabindex': '-1',
			'aria-selected': 'false'
		});

		$this.addClass('active').attr({
			'tabindex': '0',
			'aria-selected': 'true'
		});

		const currentTabId = "#" + $this.attr('aria-controls');
		const currentAnchor = $(currentTabId).find("a:first-child");
		currentAnchor.attr("tabindex", "0");

		return false;
	});
}


$(function () {
	var $dropdowns = $('#main-nav .dropdown')
	var $dropdownsLinks = $('#main-nav .dropdownLink')
	let $mainNav = document.getElementById('main-navigation')
	$dropdownsLinks.on('focus', function () {
		let $thisParent = $(this).parent()
		$dropdowns.removeClass('open')
		$dropdownsLinks.attr('aria-expanded', 'false')
		$thisParent.addClass('open')
		$(this).attr('aria-expanded', 'true')
	})

	let fitstNavChild = $('#main-nav [role=menuitem]').first()[0]
	$(fitstNavChild).on('keydown', function (e) {
		if (e.key === 'Tab' && e.shiftKey) {
			$dropdowns.removeClass('open')
			$dropdownsLinks.attr('aria-expanded', 'false')
		}
	})

	let lastNavChild = $('#main-nav [role=menuitem]').last()[0]
	$(lastNavChild).on('keydown', function (e) {
		if (e.key === 'Tab') {
			$dropdowns.removeClass('open')
			$dropdownsLinks.attr('aria-expanded', 'false')
		}
	})

	document.addEventListener('click', (evt) => {
		$mainNav
		let targetEl = evt.target // clicked element
		do {
			if (targetEl === $mainNav) {
				return
			}
			targetEl = targetEl.parentNode
		} while (targetEl)
		$dropdowns.removeClass('open')
		$dropdownsLinks.attr('aria-expanded', 'false')
	})
})
